import styled from '@emotion/styled';

// Container

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

// Header

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

// Content

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
